import React from "react";
import { HomePageLayoutTemplate } from "themes/application/home/components";

function HomePageLayout(props) {
    return <HomePageLayoutTemplate {...props} />;
}

export default HomePageLayout;
